<template>
 <page>
  
  

  <head-nav :title="$t('language.page_documents')">
    <icon-button-hamburger slot="left"></icon-button-hamburger>
    <icon-button-home slot="right"></icon-button-home>
  </head-nav>


  <scroll-page :pull-reload="true">

    <page-padding v-if="computeUserAccess">
      <button-action :to="'/documents/0/add_item/'" title="language.add_documents_item" ></button-action>
   </page-padding>

    <list-documents/>

   </scroll-page>
  </page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page';
import HeadNav from '../components/HeadNav';
import IconButtonHome from '../components/buttons/IconButtonHome';
import ListDocuments from '../components/documents/ListDocuments';
import ScrollPage from '../components/ScrollPage.vue';
import IconButtonHamburger from '../components/buttons/IconButtonHamburger';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import PagePadding from '../components/PagePadding.vue';
import { USER_LEVEL } from '../settings/USER_LEVEL.js';

export default {
  name: 'global-documents-page',
  data:function(){
    return{
    }
  },
  computed:{
     ...mapState(['group','appSettings']),
        computeUserAccess(){
        
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
       }
  },
  components: {
    ListDocuments,
    HeadNav,
    IconButtonHome,
    IconButtonHamburger,
    Page,
    ScrollPage,
    ButtonAction,
    PagePadding,
  },
  methods:{

    
  },// methods{}
  created(){
     
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
